import { render, staticRenderFns } from "./VCurrencyInput.vue?vue&type=template&id=26927be2&"
import script from "./VCurrencyInput.vue?vue&type=script&lang=js&"
export * from "./VCurrencyInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports